import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import XtmLayout from "./layouts/XtmLayout";
import Login from "./pages/Login";
import PlaceholderPage from "./pages/PlaceholderPage";
import { SIDEBAR_TABS } from "./layouts/XtmLayout";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/sign-in" element={<Login />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Navigate to="/overview" replace />} />
          <Route element={<XtmLayout />}>
            {SIDEBAR_TABS.map(tab => (
              <Route key={tab.id} path={tab.path} element={<PlaceholderPage title={tab.label} />} />
            ))}
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </HashRouter>
  );
}
